/**
 * RetirementDisclaimer Component
 * WP-RETIRE-2: Footer disclaimer always visible on retirement card
 */

export default function RetirementDisclaimer() {
  return (
    <div className="mt-4 pt-3 border-t border-gray-200">
      <p className="text-xs text-gray-500 text-center">
        <span aria-hidden="true">Warning: </span>
        Estimates only. Not financial advice. Consult a qualified advisor.
      </p>
    </div>
  );
}
